export default "__VITE_ASSET__DNY9fWh4__"